import request from "@/utils/request";

export default function agentRemoveGroupDevice(deviceId) {
    return request({
        url: `/device/deviceGroup/agentRemoveGroupDevice?deviceId=${deviceId}`,
        method: 'post',
    })
}
